import { Player } from '@lottiefiles/react-lottie-player';
import React, { useEffect, useRef } from 'react';

import { useSummaryToggle } from '../../hooks/useSummaryToggle';
import { MotionAINews } from '../../lottie/news-summary/motion_ainews';

const LOTTIE_DELAY = 500;
export const NewsSummaryPlayer = () => {
  const lottiePlayer = useRef<Player>();
  const { getShowSummary } = useSummaryToggle();
  useEffect(() => {
    const isOriginCheckedSummary = getShowSummary();

    if (isOriginCheckedSummary) {
      setTimeout(() => {
        lottiePlayer?.current?.play();
      }, LOTTIE_DELAY);
    }
  }, []);
  return <Player ref={lottiePlayer} src={MotionAINews} className="lottieWrap" />;
};
